import { SocialPost, SocialPostStage } from '@core/models';
import moment from 'moment';

/**
 * {
    "name": "New Year's Day",
    "name_local": "",
    "language": "",
    "description": "",
    "country": "AU",
    "location": "Australia",
    "type": "National",
    "date": "01/01/2020",
    "date_year": "2020",
    "date_month": "01",
    "date_day": "01",
    "week_day": "Wednesday"
   }
 */
export type SpecialCalendarEvent = {
  name: string;
  name_local: string;
  language: string;
  description: string;
  country: string;
  location: string;
  type: string;
  date: string;
  date_year: string;
  date_month: string;
  date_day: string;
  week_day: string;
};

export type ConfiguredEvent = SpecialCalendarEvent & {
  scheduledBefore?: number;
  numberOfPosts?: number;
};

export enum StudioPostStage {
  Failed = 'Failed',
  Published = 'Published',
  Scheduled = 'Scheduled',
  Draft = 'Draft',
}

export enum CalendarItemType {
  RecurringPost,
  OnceTimeOff,
}

export type CalendarItem = {
  name: string;
  description: string;
  type: CalendarItemType;
  date: string;
  date_year: number;
  date_month: number;
  date_day: number;
  social_post_id: number | undefined;
};

export enum RecurringType {
  Week = 'Weeks',
  Day = 'Days',
  Month = 'Months',
}
export const renderStatusColor = (socialPostStatus: SocialPostStage) => {
  switch (socialPostStatus) {
    case SocialPostStage.Pending:
      return 'processing';
    case SocialPostStage.Published:
      return 'success';
    case SocialPostStage.Scheduled:
      return 'yellow';
    default:
      return '';
  }
};

export const renderSocialPostStatus = (socialPost: SocialPost | undefined): SocialPostStage => {
  const now = moment().unix();
  const publishDate = moment(socialPost?.publish_at?.toString()).unix();
  if (!socialPost?.publish_at) return SocialPostStage.Pending;
  const time = publishDate - now;
  if (time > 0) {
    return SocialPostStage.Scheduled;
  } else {
    return SocialPostStage.Published;
  }
};
